import api from 'utils/api';

// NOTE: these intentionally do NOT `.catch((err) => err)`. Swallowing the
// rejection resolves the promise with an error object, which made the saga's
// catch blocks unreachable and let a failed intake signing request strand the
// patient silently (2026-08-07 incident). Let rejections reject so the saga can
// surface them. The only external consumer that relied on the old swallow is
// containers/AdminConsole/saga.js (testIntakeNew), updated alongside this.

export const intakeTestApi = (data) =>
	api
		.post(`/patient/${data.senderUserId}/intake-test`, data)
		.then((response) => response.data);

export const intakeApi = (data) =>
	api
		.post(`/patient/${data.id}/intake`, data)
		.then((response) => response.data);

export const signingApi = (data) =>
	api
		.post(`/patient/${data.id}/intake-signing`, data)
		.then((response) => response.data);
